import React, { Component } from 'react';
import { Input } from 'rsuite';

class TextInp extends Component {

    onData(event) {
        this.props.onData(event.target.value);
    }

    componentDidMount() {
		if(this.props.answer.value) {
            document.getElementById(`input${this.props.answer.id}`).value = this.props.answer.value;
        }
	}

    render() {
        const { answer } = this.props;
        return (
            <div className="answerInput">
                <Input 
                    id={`input${answer.id}`}
                    placeholder={answer.value && answer.checked ? answer.value : answer.placeholder}
                    disabled={answer.checked || answer.type === 'simple' ? false : true}
                    onBlur={this.onData.bind(this)}
                    className="inputText"
                />
            </div>
    );
    }
    
};

export default TextInp;
